// App.js
import "daterangepicker/daterangepicker.css";
import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import Inventory from "./components/Inventory";
import Replication from "./components/Replication";
import Capacity from "./components/Capacity";
import Teams from "./components/Teams";
import Kubernetes from "./components/ClusterTreeView";
import DBbackup from "./components/DBbackup";
import "./App.css";
import { ToastContainer } from "react-toastify";
import InitiateDR from "./components/InitailDR";
import RunBook from "./components/RunBook";
import EditRunbook from "./components/EditRunbook";
import { CloudProvider } from "./context/CloudProviderContext";

const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();
function App() {
  return (
    <>
    <CloudProvider>
      <MsalProvider instance={msalInstance}>
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory"
              element={
                <ProtectedRoute>
                  <Inventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/replication"
              element={
                <ProtectedRoute>
                <Replication />
                </ProtectedRoute>
              }
            />
            <Route
              path="/capacity"
              element={
                <ProtectedRoute>
                <Capacity />
                </ProtectedRoute>
              }
            />
             <Route
              path="/kubernetes"
              element={
                <ProtectedRoute>
                <Kubernetes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dbbackup"
              element={
                <ProtectedRoute>
                <DBbackup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/teams"
              element={
                <ProtectedRoute>
                <Teams />
                </ProtectedRoute>
              }
            />
            <Route
              path="/initiatedr"
              element={
                <ProtectedRoute>
                <InitiateDR />
                </ProtectedRoute>
              }
            />
            <Route
              path="/runbook"
              element={
                <ProtectedRoute>
                <RunBook />
                </ProtectedRoute>
              }
            />
            <Route
              path="/runbookEdit"
              element={
                // <ProtectedRoute>
                <EditRunbook />
                // </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </MsalProvider>
      </CloudProvider>
      <ToastContainer />
    </>
  );
}

export default App;
